/**
 * formatExplanation — parse explanation text and return an array of paragraph
 * objects ready for dangerouslySetInnerHTML rendering.
 *
 * Applies bold emphasis to:
 *   1. Rule/section references: r.2.1(d), r.2.2, s.25, Rule 2.1 etc.
 *   2. Option verdict labels: "Option A is wrong:", "Option B is correct:" etc.
 */

const RULE_RE = /\b(r\.\d+\.\d+(?:\([a-z]\))?|s\.\d+(?:\(\d+\))?|Rule \d+\.\d+)/gi;
const OPTION_LABEL_RE = /^(Option [A-E] is (?:wrong|correct|incorrect):)/gm;

function escapeHtml(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function boldify(text) {
  const escaped = escapeHtml(text);
  return escaped
    .replace(OPTION_LABEL_RE, '<strong>$1</strong>')
    .replace(RULE_RE, '<strong>$1</strong>');
}

export function formatExplanation(text) {
  if (!text) return [];
  return text
    .split('\n')
    .map(para => para.trim())
    .filter(Boolean)
    .map((para, i) => ({ key: i, __html: boldify(para) }));
}
